export default __webpack_public_path__ + "static/media/portfolio-95.195e2318.jpg";